module.exports = __webpack_public_path__ + "Пользовательское_соглашение.pdf";